import React from 'react';
import '../../styles/Nosotros/comoLoHacemos.scss';

export const ComoLoHacemos = () => {
  return (
    <div className="como-lo-hacemos">
      <div className="como-lo-hacemos-container">
        <h2 data-aos="fade-down">Cómo lo hacemos</h2>
        <div className="como-lo-hacemos-detail-grid">
          <div className="detail-card" data-aos="fade-right">
            <div className="card-content">
              <div className="card-front">
                <p className="word">Personalización</p>
              </div>
              <div className="card-back">
                <p>
                  Analizamos a fondo las necesidades de nuestros clientes para comprender su contexto y requerimientos específicos.
                </p>
              </div>
            </div>
          </div>
          <div className="detail-card dc-image-1" data-aos="fade-left"></div>
          <div className="detail-card" data-aos="fade-right">
            <div className="card-content">
              <div className="card-front">
                <p className="word">Optimización</p>
              </div>
              <div className="card-back">
                <p>
                  Mantenemos un proceso de feedback continuo para ajustar y afinar nuestra búsqueda hasta encontrar al candidato ideal.
                </p>
              </div>
            </div>
          </div>
          <div className="detail-card dc-image-2" data-aos="fade-left"></div>
          <div className="detail-card" data-aos="fade-right">
            <div className="card-content">
              <div className="card-front">
                <p className="word">Consultoría</p>
              </div>
              <div className="card-back">
                <p>
                  Brindamos asesoría para ofrecer una perspectiva integral sobre la posición en el mercado y la competitividad de la oferta.
                </p>
              </div>
            </div>
          </div>
          <div className="detail-card dc-image-3" data-aos="fade-left"></div>
          <div className="detail-card" data-aos="fade-right">
            <div className="card-content">
              <div className="card-front">
                <p className="word">Evaluación</p>
              </div>
              <div className="card-back">
                <p>
                  Elaboramos informes detallados de entrevistas, enfocados en las competencias clave y alineados con los valores y objetivos
                  de cada organización.
                </p>
              </div>
            </div>
          </div>
          <div className="detail-card dc-image-4" data-aos="fade-left"></div>
          <div className="detail-card" data-aos="fade-up">
            <div className="card-content">
              <div className="card-front">
                <p className="word">Experiencia</p>
              </div>
              <div className="card-back">
                <p>
                  Nos aseguramos de que cada etapa del proceso de selección proporcione una experiencia positiva tanto para los candidatos
                  como para nuestros clientes, preservando y fortaleciendo la marca empleadora.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
